// extracted by css-extract-rspack-plugin
export default {"container":"OutstreamVideoAd-module__container___NJcKm","center":"OutstreamVideoAd-module__center___tH4kg"};